import Vue from "vue";
import Vuex from "vuex";
import ui from "./ui";
import user from "./user";
import organizations from "./organizations";
import talent from "./talent";
import contact from "./contact";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    timeStamp: Date.now(),
    talentUrl: process.env.VUE_APP_TALENT_HOST,
  },
  mutations: {
    SET_TIME_STAMP(state) {
      state.timeStamp = Date.now();
    },
  },
  actions: {},
  modules: {
    ui,
    user,
    talent,
    contact,
    organizations,
  },
});
